import { flow, Runtime, pipe, Option, ReadonlyArray } from "fp";
import { QueryKey } from "react-query";

import * as Job from "~/Job";
import { Request } from "~/Request";
import * as WorkCode from "~/WorkCode";

export namespace Query {
  export const tag = () => "Jobs" as const;

  export const key = (): QueryKey => [tag()];

  export const runtime = () =>
    Runtime.strict({
      id: Runtime.number(),
      name: Runtime.string(),
      work_codes: Runtime.nullable(Runtime.array(WorkCode.Response.runtime())),
    });

  /**
   * [API Documentation](http://equipmentshare.pages.internal.equipmentshare.com/equipmentshare-api/master/index.html?highlight=jobs#get--jobs)
   *
   * It's unclear how the API knows which company to return jobs for. Company
   * information is likely read from the token.
   */
  export const request = (): Request.Fn<readonly Job.Job[]> =>
    flow(
      Request.fromConfig({
        endpoint: "/jobs?work_codes=True",
        headers: { "X-Fields": "{ id, name, work_codes }" },
      }),
      Request.Expect.status(200),
      Request.Expect.json(Runtime.array(runtime())),
      Request.onSuccess(
        ReadonlyArray.map((response) => ({
          id: `${response.id}`,
          name: response.name,
          workCodes: pipe(
            Option.fromNullable(response.work_codes),
            Option.map(ReadonlyArray.map(WorkCode.Response.decode)),
            Option.toUndefined
          ),
        }))
      )
    );
}
